import { useEffect } from 'react';
export default function SocialSignInServices() {
  useEffect(() => {
    const appId = process.env.REACT_APP_FACEBOOK_APP_ID;
    if (!appId) return;
    window.fbAsyncInit = () => {
      window.FB?.init({ appId, cookie: false, xfbml: false, version: 'v20.0' });
    };
    const script = document.createElement('script');
    script.id = 'facebook-jssdk'; script.async = true; script.defer = true;
    script.src = 'https://connect.facebook.net/en_US/sdk.js';
    document.head.appendChild(script);
    return () => { script.remove(); window.fbAsyncInit = undefined; window.FB = undefined; };
  }, []);
  return null;
}
